/* TODO: t() */
import React, { Component } from 'react';
import {
  Image,
  View,
  TouchableOpacity,
  StyleSheet,
  StyleProp,
  TextStyle,
  ViewStyle,
} from 'react-native';

import Text from './Text';
import { themeColors } from './Constants';
import { Checkbox } from '../../core-ui';

const arrow =
  'data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTggMTgiIHN0eWxlPSJoZWlnaHQ6MTZweDt3aWR0aDoxNnB4O2Rpc3BsYXk6YmxvY2s7ZmlsbDojQUFBQUFBIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSAiaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PHBhdGggZD0ibTE2LjI5IDQuM2ExIDEgMCAxIDEgMS40MSAxLjQybC04IDhhMSAxIDAgMCAxIC0xLjQxIDBsLTgtOGExIDEgMCAxIDEgMS40MS0xLjQybDcuMjkgNy4yOXoiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PC9wYXRoPjwvc3ZnPg==';

type State = {
  isCollapsed: boolean;
};

type Props = {
  noLeftCheckbox?: boolean;
  isChecked: boolean | null;
  onChecked?: () => void;
  style?: StyleSet;
  contentStyle?: StyleSet;
  titleStyle?: StyleProp<TextStyle>;
  title?: string;
  titleComponent?: React.ReactNode;
  touchableRowStyle?: StyleProp<ViewStyle>;
  counter?: string;
  subtitle?: string | null | undefined;
  titleOnExpand?: string;
  children?: React.ReactNode;
  initialCollapseState: boolean;
  isDisabled?: boolean;
  helpMessage?: string;
};

class CollapsibleView extends Component<Props, State> {
  static defaultProps = {
    initialCollapseState: false,
    isDisabled: false,
    isChecked: false,
  };

  state: State = {
    isCollapsed: this.props.initialCollapseState,
  };

  render() {
    let {
      title,
      titleOnExpand,
      style,
      subtitle,
      counter,
      contentStyle,
      titleStyle,
      children,
      isChecked,
      noLeftCheckbox,
      isDisabled,
      helpMessage,
      titleComponent,
      touchableRowStyle,
    } = this.props;
    let { isCollapsed } = this.state;

    return (
      <View style={[styles.root, isCollapsed && styles.collapsedRoot, style]}>
        {!noLeftCheckbox && (
          <View style={styles.checkboxDiv}>
            <Checkbox
              isIndeterminate={isChecked == null}
              isChecked={isChecked ?? false}
              onChange={this._onCheck}
              borderColor="#657786"
              paddingRight="10px"
            />
          </View>
        )}
        <View style={styles.flexOne}>
          <TouchableOpacity
            style={[styles.touchableRow, touchableRowStyle]}
            onPress={this._toggleCollapse}
            accessibilityRole="button"
            disabled={isDisabled}
          >
            <View style={styles.titleContainer}>
              <Text style={[styles.buttonText, titleStyle, styles.titleText]}>
                {!isCollapsed && titleOnExpand ? titleOnExpand : title}
              </Text>
              {counter && <Text style={styles.counterText}>{counter}</Text>}
            </View>
            {titleComponent}

            {!isDisabled && (
              <>
                <Text style={styles.help}>{helpMessage ?? 'View dates'}</Text>

                <View
                  style={[
                    styles.arrowUp,
                    isCollapsed && styles.chevronDown,
                    styles.arrowMargin,
                  ]}
                >
                  <Image
                    source={{
                      uri: arrow,
                      height: 18,
                      width: 18,
                    }}
                  />
                </View>
              </>
            )}
          </TouchableOpacity>
          {isCollapsed || !subtitle ? null : (
            <Text type="label" style={styles.subtitle}>
              {subtitle}
            </Text>
          )}

          <View
            style={[
              styles.content,
              isCollapsed && styles.collapsedContent,
              contentStyle,
            ]}
          >
            {isCollapsed ? null : children}
          </View>
        </View>
      </View>
    );
  }

  _toggleCollapse = () => {
    this.setState({ isCollapsed: !this.state.isCollapsed });
  };

  _toCollapsed = () => {
    this.setState({ isCollapsed: false });
  };

  _onCheck = () => {
    let { onChecked } = this.props;
    if (onChecked) {
      onChecked();
    }
  };
}

let transitionStyle = {
  transitionDuration: '0.25s',
  transitionTimingFunction: 'ease-out',
};

let styles = StyleSheet.create({
  root: {
    backgroundColor: 'grey',
    borderColor: 'transparent',
    paddingVertical: 6,
    borderRadius: 3,
    borderWidth: 1,
    userSelect: 'none',
    flexDirection: 'row',
    // Using `transitionProperty: all` creates lags in the transition
    transitionProperty: 'background-color, border-color',
    ...transitionStyle,
  },
  checkboxDiv: {
    paddingVertical: 8,
    paddingLeft: 2,
    paddingRight: 5,
  },
  flexOne: {
    flex: 1,
  },
  collapsedRoot: {
    borderColor: '#ccc',
    backgroundColor: '#fff',
  },
  touchableRow: {
    flexDirection: 'row',
    alignItems: 'center',
    maxWidth: '100%',
  },
  titleContainer: {
    flexDirection: 'row',
    paddingHorizontal: 12,
    maxWidth: '70%',
  },
  titleText: {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    overflow: 'auto', // overflow auto works and is used to fix overflow text
  },
  buttonText: {
    color: '#333',
    fontSize: 14,
    lineHeight: 20,
    marginVertical: 5,
    marginRight: 15,
  },
  help: {
    color: '#696969',
    fontSize: 12,
    lineHeight: 20,
    marginVertical: 5,
    marginLeft: 'auto',
    marginRight: 15,
  },
  counterText: {
    color: themeColors.darkGrey,
    fontSize: 14,
    lineHeight: 20,
    marginVertical: 5,
    marginLeft: 5,
  },
  collapsedContent: {
    maxHeight: 0,
    paddingTop: 0,
  },
  content: {
    overflow: 'hidden',
    paddingTop: 10,
    maxHeight: '100%',
    transitionProperty: 'maxHeight',
    ...transitionStyle,
  },
  arrowUp: {
    transitionProperty: 'transform',
    transform: [{ rotate: '-0.5turn' }],
    ...transitionStyle,
  },
  chevronDown: {
    transform: [{ rotate: '0turn' }],
  },
  subtitle: {
    color: themeColors.mainNavText,
    fontStyle: 'italic',
    paddingHorizontal: 12,
  },
  arrowMargin: {
    marginRight: 10,
  },
});

export default CollapsibleView;
